/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './array-data-source';
export * from './collection-viewer';
export * from './data-source';
export * from './dispose-view-repeater-strategy';
export * from './recycle-view-repeater-strategy';
export * from './selection-model';
export {
  UniqueSelectionDispatcher,
  UniqueSelectionDispatcherListener,
} from './unique-selection-dispatcher';
export * from './tree-adapter';
export * from './view-repeater';



// WEBPACK FOOTER //
// ../../../../../src/cdk/collections/public-api.ts